import {
  checkStatus,
  handleRequestError,
} from '../utils/helpers';
import config from '../../config';

export const sendAppLinkSms = (brandId, phone) => {
  const url = brandId
    ? `${config.url}/brand/${brandId}/sms-app-link`
    : `${config.url}/customer/sms-app-link`;
  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      phone,
    }),
  })
    .then(checkStatus)
    .catch(handleRequestError);
};

export const sendReminderSMSLinkClickedEvent = (customerId, brandId, redirectLink, userAgent) => {
  const url = `${config.fullstory.url}/v2/events`;
  const name = 'Rebooking Reminder SMS Link Clicked';
  const event = {
    user: {
      uid: customerId,
    },
    name,
    timestamp: new Date().toISOString(),
    properties: {
      source: 'Squire Web',
      title: `Customer ${customerId}: ${name}`,
      customer_id: customerId,
      brand_id: brandId,
      redirect_link: redirectLink,
      user_agent: userAgent,
    },
  };

  return fetch(url, {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Basic ${config.fullstory.apiKey}`,
    },
    body: JSON.stringify(event),
  })
    .then(checkStatus)
    .catch(handleRequestError);
};



// WEBPACK FOOTER //
// ./src/app/mobileApp/actions.js